
<v-flex>
    <card-collection
        class="px-0-nested"
        :meta="meta"
        :busy="overlay"
        @updated="updated"
    >
        <template #data>
            <thead>
            <tr>
                <th>{{ t('main_goal_label_id') }}</th>
                <th>{{ t('main_goal_label_title') }}</th>
                <th>{{ t('main_goal_label_type') }}</th>
                <th>{{ t('main_goal_label_plan_type') }}</th>
                <th>{{ t('main_goal_label_status') }}</th>
                <th>{{ t('main_goal_label_start_at') }}</th>
                <th>{{ t('main_goal_label_end_at') }}</th>
                <th>{{ t('main_goal_label_duration') }}</th>
                <th>{{ t('main_goal_label_program') }}</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="collection.data.length === 0">
                <td class="text-center" colspan="10">{{ t('general_text_no_data') }}</td>
            </tr>
            <template v-else v-for="goal in collection.data">
                <tr>
                    <td>
                        <a href="javascript:" @click.prevent="touch(goal)">{{ goal.id }}</a>
                    </td>
                    <td>
                        <a href="javascript:" @click.prevent="touch(goal)">{{ goal.title }}</a>
                    </td>
                    <td>{{ mainGoalTypeTitle(goal.type) }}</td>
                    <td>{{ goal.planType ? planTypeTitle(goal.planType) : '-' }}</td>
                    <td>
                        <v-chip
                            small
                            :color="statusColor(goal.status)"
                            text-color="white"
                        >{{ mainGoalStatusTitle(goal.status) }}</v-chip>
                    </td>
                    <td>{{ goal.startAt ? goal.startAt.format('DD/MM/YYYY') : '-' }}</td>
                    <td>{{ goal.endAt ? goal.endAt.format('DD/MM/YYYY') : '-' }}</td>
                    <td>{{ goal.durationFormatted || '-' }}</td>
                    <td>{{ goal.program ? goal.program.name : '-' }}</td>
                    <td class="text-right">
                        <confirm-modal
                            :title="t('general_title_confirm_action')"
                            @agree="del(goal)"
                        >
                            <template #default="{ on, attrs }">
                                <v-btn
                                    icon
                                    small
                                    color="orange"
                                    v-on="on"
                                    v-bind="attrs"
                                ><v-icon small>mdi-delete-outline</v-icon></v-btn>
                            </template>
                        </confirm-modal>
                    </td>
                </tr>
            </template>
            </tbody>
        </template>
    </card-collection>
</v-flex>
